import { useParams, Link, Navigate } from "react-router-dom";
import { ArrowLeft, Clock3, Layers3 } from "lucide-react";
import Seo from "@/lib/Seo";
import { PATHS } from "@/content/site";
import { PROJECTS } from "@/content/projects";
import FinalCTA from "@/sections/FinalCTA";
import Reveal from "@/components/Reveal";

export default function ImpactDetail() {
  const { slug } = useParams();
  const project = PROJECTS.find((p) => p.slug === slug);
  if (!project) return <Navigate to="/impact#projects" replace />;
  const path = PATHS.find((p) => p.slug === project.pathSlug);
  const related = PROJECTS.filter((p) => p.pathSlug === project.pathSlug && p.slug !== project.slug).slice(0,3);

  const jsonLd = {"@context":"https://schema.org","@type":"Article",headline:project.title,inLanguage:"ar",about:project.excerpt};

  return <>
    <Seo path={`/impact/${project.slug}`} title={project.title} description={project.excerpt} type="article" jsonLd={jsonLd} />
    <article className="bg-navy text-white pt-32 pb-20">
      <div className="mx-auto max-w-[1100px] px-6 sm:px-10">
        <nav aria-label="مسار التنقل" className="text-sm text-white/55 mb-8">
          <Link to="/impact#projects" className="hover:text-white">أثرنا</Link><span className="mx-2">/</span><span className="text-white/80">{project.title}</span>
        </nav>
        <div className="flex flex-wrap items-center gap-4 text-sm">
          {path && <span className="inline-flex items-center gap-2 text-peach"><Layers3 size={15}/>{path.title}</span>}
          <span className="inline-flex items-center gap-2 text-white/70"><Clock3 size={15}/>{path?.title || "مشروع سياق"}</span>
        </div>
        <h1 className="font-display leading-tight max-w-4xl mt-5" style={{fontSize:"clamp(2rem,4vw,3.8rem)"}}>{project.title}</h1>
        <p className="text-white/70 text-lg sm:text-xl leading-relaxed max-w-3xl mt-6">{project.excerpt}</p>
      </div>
    </article>

    <div className="bg-paper py-20 sm:py-28">
      <div className="mx-auto max-w-[1100px] px-6 sm:px-10">
        <div className="grid lg:grid-cols-[1fr_280px] gap-12">
          <Reveal>
            <span className="eyebrow">عن المشروع</span>
            <h2 className="font-display text-navy text-3xl mt-4">ما عملنا عليه</h2>
            <p className="text-blue text-lg leading-loose mt-6">{project.body}</p>
          </Reveal>
          <aside className="border-t-2 border-coral pt-6 self-start">
            <dl className="space-y-6">
              <div><dt className="text-sm text-blue/65">مسار التأثير</dt><dd className="font-display text-navy text-lg mt-1">{path?.title || "—"}</dd></div>
              {project.duration && <div><dt className="text-sm text-blue/65">مدة المشروع</dt><dd className="font-display text-navy text-lg mt-1">{project.duration}</dd></div>}
            </dl>
          </aside>
        </div>

        {related.length > 0 && <section className="mt-24 border-t border-navy/10 pt-14">
          <span className="eyebrow">ضمن المسار نفسه</span>
          <h2 className="font-display text-navy text-3xl mt-4">مشاريع ذات صلة</h2>
          <div className="grid md:grid-cols-3 mt-8 border-t border-navy/10">
            {related.map((item)=><Link key={item.slug} to={`/impact/${item.slug}`} className="group py-7 md:px-6 border-b md:border-l border-navy/10">
              <span className="text-sm text-purple">{PATHS.find((p) => p.slug === item.pathSlug)?.title || ""}</span>
              <h3 className="font-display text-navy text-lg leading-snug mt-3 group-hover:text-coral">{item.title}</h3>
              <span className="inline-flex items-center gap-2 text-coral mt-5">عرض المشروع <ArrowLeft size={15}/></span>
            </Link>)}
          </div>
        </section>}

        <Link to="/impact#projects" className="mt-14 inline-flex items-center gap-2 text-navy border border-navy/20 px-6 py-3 hover:bg-navy hover:text-white transition-colors"><ArrowLeft size={16}/>العودة إلى جميع المشاريع</Link>
      </div>
    </div>
    <FinalCTA />
  </>;
}
